import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { Heading, Section } from './Primitives';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section id="faq" className="bg-cream" ariaLabel="Frequently asked questions" data-id="element-26" data-mp="1gd7h4a4s9d6j">
      <div className="mx-auto max-w-xl text-center" data-id="element-27" data-mp="2e067y48snqwi">
        <Heading data-id="element-28" data-mp="2dzxvgdgl2nlu">Questions, answered.</Heading>
      </div>

      <div className="mx-auto mt-9 max-w-2xl space-y-3" data-id="element-29" data-mp="290to7sd7yzy5">
        {faqs.map((faq, index) => {
        const isOpen = openIndex === index;
        return <div key={faq.question} className="overflow-hidden rounded-2xl border border-orangey-100 bg-white" data-id="element-30" data-mp="24436l0lrnwam" data-mpi={index}>
              <h3 data-id="element-31" data-mp="sn3heduptxkt">
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left font-display text-lg font-bold text-ink-900 transition-colors hover:text-orangey-700 sm:px-6" data-id="element-32" data-mp="snmnmxb06xj0">
                  {faq.question}
                  <motion.span animate={{
                rotate: isOpen ? 45 : 0
              }} transition={{
                duration: 0.2
              }} className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-orangey-100 text-orangey-700" data-id="element-33" data-mp="fm4gldcsv211">
                    <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-34" data-mp="bjhnl94e7b29" />
                  </motion.span>
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-35" data-mp="1ru0fkevcg6l">
                {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.24,
              ease: 'easeOut'
            }} data-id="element-36" data-mp="3jxyijf5evord">
                    <p className="px-5 pb-5 leading-relaxed text-ink-500 sm:px-6" data-id="element-37" data-mp="1pp352bb9zgck">{faq.answer}</p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </Section>;
}